export const tooltip = (tokens) => {
    const { tooltip } = tokens.component;
    return {
        MuiTooltip: {
            defaultProps: {
                arrow: true,
            },
            styleOverrides: {
                tooltip: {
                    backgroundColor: tooltip.light.backgroundColor.value,
                    boxShadow: tooltip.boxShadow.value.stringValue,
                    color: tooltip.color.value,
                    fontSize: tooltip.fontSize.value,
                    lineHeight: tooltip.lineHeight.value,
                    fontWeight: tooltip.fontWeight.value,
                    padding: `${tooltip.paddingVertical.value} ${tooltip.paddingHorizontal.value}`,
                    borderRadius: tooltip.borderRadius.value,
                    maxWidth: tooltip.maxWidth.value,
                },
                arrow: {
                    color: tooltip.light.backgroundColor.value,
                    // This to make sure boxShow goes around arrow shape not rectangle
                    width: "2em",
                    "&::before": {
                        backgroundColor: tooltip.light.backgroundColor.value,
                        boxShadow: tooltip.boxShadow.value.stringValue,
                        width: "1em",
                        height: "0.71em",
                    },
                },
                popper: ({ ownerState }) => {
                    const { placement } = ownerState;
                    const sideArrow = ["left-start", "left", "left-end", "right-start", "right", "right-end"];
                    const isSideArrow = placement && sideArrow.includes(placement);
                    return Object.assign({}, (isSideArrow && {
                        "&& .MuiTooltip-arrow": {
                            height: "2em",
                            "::before": {
                                height: "1em",
                                width: "0.71em",
                            },
                        },
                    }));
                },
            },
        },
    };
};
export default tooltip;
//# sourceMappingURL=tooltip.js.map